export default "__VITE_ASSET__7142ca8e__"